export default __webpack_public_path__ + "static/media/img2.247c7b29.jpg";